import { useStackedModals } from "@sazka/utils/composables/use-stacked-modals";
import { ref } from "vue";

/* Used by authenticated variant of header */
const drawAttendancePopupVisible = ref<boolean>(false);
const userBalancePopupVisible = ref<boolean>(false);

const menuIsOpened = ref(false);
const menuActiveClassName = "menu-active";

const menuWrapper = document.querySelector("#header");

const { addToStackedModals, removeFromStackedModals } = useStackedModals();
const openMenu = () => {
    if (!menuIsOpened.value) {
        menuWrapper.classList.add(menuActiveClassName);
        addToStackedModals();

        drawAttendancePopupVisible.value = false;
        userBalancePopupVisible.value = false;

        menuIsOpened.value = true;
    }
};

const closeMenu = () => {
    if (menuIsOpened.value) {
        menuWrapper.classList.remove(menuActiveClassName);
        removeFromStackedModals();

        menuIsOpened.value = false;
    }
};

const toggleMenu = () => {
    menuIsOpened.value ? closeMenu() : openMenu();
};

export function useHeader() {
    return {
        drawAttendancePopupVisible,
        userBalancePopupVisible,
        toggleMenu,
        closeMenu,
    };
}
